import { Modal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import {
  useSlideTemplates,
  useTemplate,
} from "MyDashboards/api/useDashboards.hook";
import useDashboardEditor from "MyDashboards/state/editor";
import { Element, Slide } from "MyDashboards/state/editorTypes";
import px from "MyDashboards/utils/px";
import scaleDashboardPages from "MyDashboards/utils/scaleDashboard";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Loader from "qpr-base/ui/components/Loader";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AddIcon } from "../../assets/addIcon.svg";
import * as renderers from "../Render";
import RenderSelectedSlide from "../SlideView/RenderSlide";
import useAddSlideModalStyles from "./themes";
const RenderElement = (props: { el: Element }) => {
  const { el } = props;
  if (props.el.component) {
    if (props.el.component.component === "Highcharts") {
      return <div>Highcharts component {props.el.component.data.message}</div>;
    }
  }
  return (
    <div
      style={{
        width: px(el.width),
        height: px(el.height),
        background: "rgba(0,100,255,0.1)",
      }}
    />
  );
};
const Layout = (props: { slide: Slide; width: number }) => {
  const classes = useAddSlideModalStyles();
  const { slide, width } = props;
  const editorWidth = useDashboardEditor((e) => e.editorWidth);
  const [scaledSlide] = scaleDashboardPages(editorWidth / slide.width, [slide]);
  return (
    <div
      className={classes.slidePrev}
      style={{ height: px((width * slide.height) / slide.width) }}
    >
      <RenderSelectedSlide
        slide={scaledSlide}
        width={(width * editorWidth) / scaledSlide.width}
        RenderElement={RenderElement}
        containerClass="thumb"
        registry={renderers.template}
      />
    </div>
  );
};

interface AddSlideModalProps {
  open: boolean;
  onClose: VoidFunction;
  onLayoutSelected: (layout: Slide) => void;
}

const AddSlideModal: FunctionComponent<AddSlideModalProps> = (props) => {
  const classes = useAddSlideModalStyles();
  const { t } = useTranslation();
  const ctx = useAppContext();
  const editorWidth = useDashboardEditor((s: any) => s.editorWidth);

  const { data: tpl, isLoading } = useTemplate(
    `/report/templates/report_slide_templates_${
      ctx.language === "ar" ? "ar" : "en"
    }.pptx`
  );
  const { data: slideTpls, isLoading: isSlideTplLoading } = useSlideTemplates();

  if (
    ctx.page === "viewdashboard" ||
    ctx.page === "editdashboard" ||
    ctx.page === "createdashboard"
  ) {
    return (
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          dir={ctx.rtl ? "rtl" : "ltr"}
          open={props.open}
          onClose={props.onClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          style={{ zIndex: 99999 }}
          BackdropProps={{
            timeout: 500,
          }}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <Fade in={props.open}>
              <div className={classes.body}>
                <div className="title">
                  <div className="icon">
                    <div className="bg">
                      <AddIcon />
                    </div>
                  </div>
                  <div className="titleText">{t("myStories.Add slide")}</div>
                  <div
                    className="closeIcon"
                    aria-hidden
                    onClick={props.onClose}
                  >
                    <CloseIcon />
                  </div>
                </div>

                <div className="content">
                  <div className="header">{t("myStories.Select Layout")}</div>
                  <div className="layouts">
                    {(slideTpls || [])
                      .filter((board) =>
                        ctx.rtl
                          ? board.languageName === "ar"
                          : board.languageName === "en"
                      )
                      .map((dashboard) =>
                        (dashboard.dashboardData?.pages || []).map((val) => (
                          <div
                            onClick={() => props.onLayoutSelected(val)}
                            aria-hidden
                            key={val.id}
                          >
                            <Layout slide={val} width={220} />
                          </div>
                        ))
                      )}
                  </div>
                </div>
              </div>
            </Fade>
          )}
        </Modal>
      </div>
    );
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        dir={ctx.rtl ? "rtl" : "ltr"}
        open={props.open}
        onClose={props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        style={{ zIndex: 99999 }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {isLoading ? (
          <Loader />
        ) : (
          <Fade in={props.open}>
            <div className={classes.body}>
              <div className="title">
                <div className="icon">
                  <div className="bg">
                    <AddIcon />
                  </div>
                </div>
                <div className="titleText">{t("myStories.Add slide")}</div>
                <div className="closeIcon" aria-hidden onClick={props.onClose}>
                  <CloseIcon />
                </div>
              </div>

              <div className="content">
                <div className="header">{t("myStories.Select Layout")}</div>
                <div className="layouts">
                  {tpl?.pages.map((val) => (
                    <div
                      onClick={() => props.onLayoutSelected(val)}
                      aria-hidden
                      key={val.id}
                    >
                      <Layout slide={val} width={220} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Fade>
        )}
      </Modal>
    </div>
  );
};

export default AddSlideModal;
